import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "react-bootstrap";
import UserSideBarMenu from "../Component/UserSidebarMenu";
import TopHeader from "../Component/TopHeader";
import PaymentsFilters from "../Component/Filters/PaymentsFilters";
import KebabMenu from "../Component/KebabMenu";
import FilterPopover from "../Component/FilterPopover";
import StatusDot from "../Component/StatusDot";
import Pagination from "../Component/Pagination";
import { getUserPaymentsListAction } from "../../Store/Actions/BookingActions";
import { display, showToast } from "../../utils/helper";
import { toggleRightSidebarAction } from "../../Store/Actions/AuthActions";
import DetailsRightSidebar from "../Component/DetailsRightSidebar";

const PaymentsList = () => {
  const dispatch = useDispatch();
  const menuState = useSelector((state) => state.auth.isMenuOpen);
  const rightSidebar = useSelector((state) => state.auth.isRightSidebarOpen);

  const { paymentList } = useSelector((state) => state.bookings);

  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [showSidebar, toggleShowRightSidebar] = useState({
    show: false,
    item: {},
  });

  const stripEmpty = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(([, v]) => v !== "" && v !== null && v !== undefined),
    );

  const [pagging, setPagging] = useState({
    totalItems: "",
    itemsPerPage: "",
    currentPage: "",
    totalPages: "",
    nextPage: 1,
    limit: 15,
  });

  const renderPagging = () => (
    <Pagination
      currentPage={pagging.currentPage || 1}
      totalPages={pagging.totalPages || 1}
      totalItems={pagging.totalItems}
      onPageChange={(p) => getPaymentsList(p)}
    />
  );

  const getPaymentsList = (page = 1, overrideFilters) => {
    if (!loading) {
      setLoading(true);

      const listParams = {
        page,
        limit: pagging.limit,
        ...stripEmpty(overrideFilters || filters),
      };

      getUserPaymentsListAction(listParams, dispatch)
        .then((res) => {
          if (res.type === "success") {
            setPagging({
              ...pagging,
              ...res.pagination,
            });
          }
        })
        .catch((err) => {
          showToast("error", err.message);
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    getPaymentsList();
  }, []);

  return (
    <div className={`app-wrapper ${menuState ? "open" : ""} `}>
      <UserSideBarMenu />

      <div className="content-wrapper">
        <TopHeader title={"Payments"} />

        <div className="content">
          <div className="list-toolbar">
            <div className="list-toolbar-spacer" />

            <FilterPopover
              count={
                Object.values(filters).filter(
                  (v) => v !== "" && v !== null && v !== undefined,
                ).length
              }
            >
              {(close) => (
                <PaymentsFilters
                  initial={filters}
                  onApply={(values) => {
                    setFilters(values);
                    getPaymentsList(1, values);
                    close();
                  }}
                />
              )}
            </FilterPopover>
          </div>

              <div className="data-listing">
                <table className="table">
                  <thead className="thead-light">
                    <tr>
                      <th width="13%">Spot</th>
                      <th width="18%">User</th>
                      <th width="14%" className="text-center">
                        Amount
                      </th>
                      <th width="20%" className="text-center">
                        Transaction ID
                      </th>
                      <th width="12%">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentList.length > 0 &&
                      paymentList.map((item) => (
                        <tr key={`pmt-${item.id}`}>
                          <td>{display(item.spot && item.spot.name)}</td>
                          <td>{display(item.spot && item.spot.address)}</td>
                          <td className="text-center">${display(item.grossAmount, "0")}</td>
                          <td className="text-center">
                            {display(item.stripePaymentIntentId)}
                          </td>
                          <td>
                            <StatusDot status={item.status} kind="payment" />
                          </td>
                          {/* <td>
                            <Button
                              onClick={() => {
                                toggleShowRightSidebar({ show: true, item });
                                toggleRightSidebarAction(true, dispatch);
                              }}
                              className="btn solid mr-2 btn-rounded"
                            >
                              <i className="fas fa-eye" />
                            </Button>

                            <Button
                                onClick={() => deleteBooking(item)}
                                className="btn solid btn-danger btn-rounded"
                              >
                                {!delLoading[item.id] && (
                                  <i className="fas fa-trash" />
                                )}

                                {delLoading[item.id] && (
                                  <i className="fas fa-spin fa-spinner" />
                                )}
                              </Button>
                          </td> */}
                        </tr>
                      ))}{" "}
                    {paymentList.length === 0 && (
                      <tr>
                        <td colSpan="6">
                          <p className="text-center">No Payments Available.</p>
                        </td>
                      </tr>
                    )}
                    {loading && (
                      <tr>
                        <td colSpan="6">
                          <p className="text-center">
                            <i className="fas fa-spinner fa-spin" />
                          </p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {renderPagging()}
        </div>
      </div>

      {showSidebar.show && (
        <DetailsRightSidebar
          item={showSidebar.item}
          closeSidebar={() => {
            toggleShowRightSidebar({ show: false, item: {} });
          }}
        />
      )}
    </div>
  );
};

export default PaymentsList;
